<template>
  <div class="issue-select-table-cell" @click.stop>
    <v-simple-checkbox
      :value="isSelected"
      :ripple="false"
      color="primary"
      dense
      @input="$emit('toggleSelect', item)"
    />
  </div>
</template>

<script>
export default {
  name: 'IssueSelectTableCell',
  props: {
    item: {
      type: Object,
      required: true,
    },
    column: {
      type: Object,
      required: true,
    },
    selectedIds: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    isSelected() {
      return this.selectedIds.includes(this.item.id);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/design-system';

.issue-select-table-cell {
  display: flex;
  align-items: center;
  // Left-align the checkbox under the "Issues" title (matches its $space-8 inset).
  justify-content: flex-start;
  padding-left: $space-8;
  height: 100%;
  width: 100%;

  ::v-deep .v-simple-checkbox {
    line-height: 0;
  }
  ::v-deep .v-icon {
    margin: 0;
  }
}
</style>
